import { DSPaginatedList, DSPostShortWithAuthor } from 'shared-definitions/types'
import { ApiResponsePostsList } from 'data-source/types.wp'
import {
  onePostWithAuthorMapper,
  OnePostWithAuthorMapperOpts,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'

export function codecPostsList(
  raw: ApiResponsePostsList,
  opts: OnePostWithAuthorMapperOpts
): DSPaginatedList<DSPostShortWithAuthor> {
  return {
    ...paginationMapper(raw.data),
    items: raw.data.posts.map(i => onePostWithAuthorMapper(i, opts)),
  }
}
